import { put, call, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      uuid: item.user_uuid,
      avatar: item.user_avatar_url,
      email: item.user_email,
      name: item.user_name,
      status: item.invitation_status
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getReferralConnections({ payload: { signal, curr_page } }) {
  try {
    const { data } = yield call(fetch, { api: api.refer.connections, params: { page: curr_page }, signal });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      connections: data.results,
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.previous
    };

    yield put(actions.getReferralsConnectionsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getReferralsConnectionsFailed,
      endpoint: api.refer.connections.url
    });
  }
}

export const getReferralConnectionsSaga = takeEvery(types.GET_REFERRALS_CONNECTIONS_REQUEST, getReferralConnections);